export const sameStringList = (
  a: readonly string[] | null | undefined,
  b: readonly string[] | null | undefined,
): boolean => {
  if (!Array.isArray(a) || !Array.isArray(b)) return false
  if (a.length !== b.length) return false
  return a.every((value, index) => value === b[index])
}
